import { NavLink, Outlet, Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import Logo from "../components/Logo";
import { House, EnvelopeSimple, ChartLineUp, Megaphone, Barbell, CalendarDots, SignOut, UserCircle, ChatCircleText, Plug, Money, Shield, Swap, Article, Envelope, GraduationCap, Robot, ArrowsClockwise, Lightning, Storefront, Trophy, Target, CheckSquareOffset, BookOpen, Medal, UserPlus, Books, Heart, Users, Tag, Receipt, Buildings, Handshake, Sun, Baby, CaretDown, CaretRight, Sparkle, Star, ClipboardText, Bell, X, Moon } from "@phosphor-icons/react";
import { useEffect, useState, useRef } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import CommandPalette from "../components/CommandPalette";
import MascotChat from "../components/MascotChat";
import { DraggableWidget } from "../components/ui/DraggableWidget";
import EmailQuotaBadge from "../components/EmailQuotaBadge";
import { ConfidentialityGate } from "../components/reception/ConfidentialityGate";
import { useTheme } from "../components/ThemeToggle";
import { LEGACY_REDIRECTS, HUB_META } from "../lib/legacyRoutes";
import GuidedTour from "../components/GuidedTour";
import InstallAppBanner from "../components/InstallAppBanner";

// 🧭 Navigation par PÔLES (RBAC) — ~50 entrées, hubs à onglets. Aucune URL publique modifiée ; anciennes URL redirigées (lib/legacyRoutes.js).
const NAV_GROUPS_RAW = [
  {
    id: "reception",
    label: "Réception — Prospects",
    icon: Users,
    roles: ["reception_prospects"],
    items: [
      { to: "/app/reception", label: "📞 Mon tableau Réception", icon: Users, desc: "Mes prospects assignés, relances, tâches" },
      { to: "/app/centre-suivi", label: "Centre de suivi (mes fiches)", icon: Users, desc: "Fiches assignées, notes, statuts, modèles" },
      { to: "/app/inbox-sociale", label: "Inbox sociale", icon: Users, desc: "Facebook / Instagram — modèles approuvés" },
      { to: "/app/camille-phone", label: "Appels à rappeler", icon: Users, desc: "Messages vocaux Camille" },
      { to: "/app/guide-reception", label: "📘 Guide Réception", icon: Users, desc: "Script, FAQ, programmes, prix officiel, règles" },
    ],
  },
  {
    id: "pilotage",
    label: "Accueil & pilotage",
    icon: Sun,
    roles: ["admin", "coach", "comptable", "reception", "marketing"],
    items: [
      { to: "/app", label: "☀️ Mon matin", icon: Sun, exact: true, desc: "Tableau du jour · brief · incidents" },
      { to: "/app/accueil-pilotage", label: "🎛️ Accueil & Pilotage", icon: House, desc: "Vue d'ensemble, raccourcis, tâches" },
      { to: "/app/taches", label: "✅ Tâches & Notifications", icon: CheckSquareOffset },
      { to: "/app/anomalies", label: "🩺 Centre d'anomalies", icon: Shield },
      { to: "/app/automatisations", label: "⚡ Automatisations", icon: Lightning },
      { to: "/app/rapports", label: "📊 Rapports", icon: ChartLineUp },
    ],
  },
  {
    id: "fondateur",
    label: "Espace Fondateur",
    icon: Star,
    roles: ["admin"],
    owner_only: true,
    items: [
      { to: "/app/evolution", label: "🧭 Espace Évolution", icon: Star, desc: "Alignement · décisions · bilans" },
      { to: "/app/immeubles/dossier-brebeuf", label: "🔒 Dossier Brébeuf", icon: Star, desc: "876 / 878 — privé" },
      { to: "/app/cataley", label: "💎 Le Trésor de Cataleya Capital", icon: Star },
    ],
  },
  {
    id: "dojo",
    label: "Dojo & élèves",
    icon: Barbell,
    roles: ["admin", "coach", "reception"],
    items: [
      { to: "/app/calendrier", label: "🗓️ Agenda & horaires", icon: CalendarDots, desc: "Horaire des cours · été · événements · calendriers" },
      { to: "/app/presences", label: "✅ Présences", icon: CheckSquareOffset },
      { to: "/app/inscriptions-en-attente", label: "📝 Inscriptions", icon: UserPlus, badge: "pending_inscriptions" },
      { to: "/app/qr-essai", label: "🎟️ QR Cours d'essai", icon: UserPlus },
      { to: "/app/checkin-essai", label: "🥋 Check-in Cours d'essai", icon: GraduationCap },
      { to: "/app/activation-membres", label: "🔗 Activation membres", icon: UserPlus },
      { to: "/app/eleves", label: "🎓 Contrats Élèves", icon: GraduationCap, desc: "Dojo · Petits Samouraïs · PowerKick Her" },
      { to: "/app/premier-mois", label: "📋 Premier mois (Équipement)", icon: GraduationCap },
      { to: "/app/grille-tarifaire", label: "💰 Tarifs", icon: Tag, desc: "Tarifs dojo · carnets · conformité" },
      { to: "/app/academie-kaizen", label: "🧭 Centre de gestion (Académie)", icon: GraduationCap },
      { to: "/app/carnet-progression", label: "📖 Carnet Progression", icon: BookOpen },
      { to: "/app/couverture-curriculum", label: "🎯 Couverture Curriculum", icon: Target },
      { to: "/app/curriculums", label: "📚 Curriculums", icon: Books },
      { to: "/app/bibliotheque-techniques", label: "📚 Bibliothèque Tech.", icon: Books },
      { to: "/app/videos", label: "🎬 Vidéos techniques", icon: BookOpen },
      { to: "/app/entrainements-associes", label: "🥊 Entraînements associés", icon: BookOpen },
      { to: "/app/evaluation", label: "🥋 Évaluation Live", icon: Medal },
      { to: "/app/certificats", label: "📜 Certificats", icon: BookOpen },
      { to: "/app/structure-academique", label: "🥋 Référentiel niveaux · uniformes", icon: Medal },
      { to: "/app/academie", label: "🎓 Académie (en ligne)", icon: GraduationCap },
      { to: "/app/programme-amikobi", label: "🎓 Programme Amikobi", icon: GraduationCap },
      { to: "/app/tournee-regionale", label: "🚐 K'izen en tournée", icon: GraduationCap },
      { to: "/app/rythmes-connexions", label: "💃 Rythmes & Connexions", icon: Heart, desc: "Groupe social de danse · Val-d'Or" },
      { to: "/app/booking", label: "📅 Privés (coaching · booking)", icon: CalendarDots },
      { to: "/app/clients-prives", label: "🥋 Suivi clients privés", icon: CalendarDots },
      { to: "/app/coachs", label: "🎓 Espace Coach", icon: GraduationCap },
      { to: "/app/guides", label: "📘 Guides équipe", icon: BookOpen, desc: "Aide-mémoire · coach · réception" },
      { to: "/app/audit-membres", label: "📋 Audit Membres Actifs", icon: Users },
      { to: "/app/reconciliation-membres", label: "🤝 Réconciliation membres", icon: Heart },
      { to: "/app/reclamations-assurance", label: "🛡️ Réclamations assurance", icon: Shield },
      { to: "/app/apercu-membre", label: "👤 Aperçu membre (accès total)", icon: BookOpen },
    ],
  },
  {
    id: "competition",
    label: "Jeux Martiaux & événements",
    icon: Trophy,
    roles: ["admin", "coach"],
    items: [
      { to: "/app/mini-competitions", label: "🥋 Jeux Martiaux Inter-Écoles", icon: Medal },
      { to: "/app/pointage", label: "🎛 Pointage & Officiels", icon: Medal },
      { to: "/app/livestream", label: "📺 Livestream", icon: Storefront },
      { to: "/app/billetterie", label: "🎟️ Billetterie", icon: Storefront },
      { to: "/app/defi-impact-60", label: "🔥 Défi Impact 60", icon: Lightning },
      { to: "/app/reglements", label: "📜 Règlements MTO", icon: Shield },
      { to: "/app/match-validator", label: "⚖️ Validateur match", icon: Swap },
      { to: "/app/programme-ecoles", label: "🎒 Programme Écoles", icon: Article },
      { to: "/app/commandites", label: "💎 Commandites", icon: Medal },
      { to: "/app/financement", label: "💰 Financement athlètes", icon: Megaphone },
    ],
  },
  {
    id: "crm",
    label: "CRM & relations",
    icon: Users,
    roles: ["admin", "reception"],
    items: [
      { to: "/app/inbox-sociale", label: "💬 Inbox sociale", icon: ChatCircleText, desc: "FB · IG · TikTok · WhatsApp" },
      { to: "/app/centre-suivi", label: "🎯 Centre de suivi (prospects)", icon: Users },
      { to: "/app/crm-leads", label: "👥 CRM Leads", icon: Users },
      { to: "/app/admission", label: "🎯 Admissions (qualif.)", icon: Users },
      { to: "/app/suivi-personnalise", label: "🧭 Suivi personnalisé", icon: CheckSquareOffset },
      { to: "/app/conversion-globale", label: "📈 Conversion globale", icon: ChartLineUp },
      { to: "/app/retention", label: "💗 Rétention & Réabonnement", icon: Heart },
      { to: "/app/onboarding-sequence", label: "🚀 Séquence d'accueil", icon: Users },
      { to: "/app/liens-onboarding", label: "🔗 Liens Onboarding QR", icon: Storefront },
      { to: "/app/prospects-gmail", label: "📧 Prospects Gmail", icon: Lightning },
      { to: "/app/facturation-membres", label: "💳 Forfaits membres", icon: Money },
      { to: "/app/imports", label: "📥 Imports & migration", icon: Swap, desc: "Contacts · Zen Planner · bulk-edit" },
      { to: "/app/partenariats", label: "🤝 CRM Partenariats", icon: Handshake },
      { to: "/app/fournisseurs-b2b", label: "🤝 Fournisseurs B2B", icon: Plug },
    ],
  },
  {
    id: "marketing",
    label: "Marketing & contenu",
    icon: Megaphone,
    roles: ["admin", "marketing"],
    items: [
      { to: "/app/mediatheque", label: "📷 Médiathèque du dojo", icon: Megaphone, desc: "Vraies photos · vidéos · consentements" },
      { to: "/app/programmes-regles", label: "🧭 Programmes & règles", icon: Megaphone, desc: "Fiches de programme · offres officielles" },
      { to: "/app/studio-creatif", label: "🎨 Studio créatif", icon: Megaphone, desc: "Contenus IA · affiches · logos" },
      { to: "/app/publications", label: "📣 Publications & réseaux", icon: Megaphone, desc: "Facebook · Instagram · TikTok · pilote auto" },
      { to: "/app/campagnes", label: "🗓️ Campagnes", icon: Megaphone, desc: "Plan annuel · Les 3 · 30 jours · tableau" },
      { to: "/app/offres", label: "🎟️ Promos & offres", icon: Tag, desc: "Promos · codes · radar" },
      { to: "/app/avis-google", label: "⭐ Avis Google", icon: Star },
      { to: "/app/ambassadeurs", label: "🏆 Ambassadeurs du mois", icon: Trophy },
      { to: "/app/rencontre-rentree", label: "🎤 Rencontre de rentrée", icon: Megaphone },
      { to: "/app/blog", label: "📝 Blog", icon: Article },
      { to: "/app/contact", label: "✉️ Contact", icon: Envelope },
      { to: "/app/wordpress-sync", label: "🔌 WordPress Sync", icon: Plug },
    ],
  },
  {
    id: "boutique",
    label: "Boutique & monétisation",
    icon: Storefront,
    roles: ["admin"],
    items: [
      { to: "/app/boutique", label: "🛒 Boutique", icon: Storefront, desc: "Produits · Printful · cartes-cadeaux" },
    ],
  },
  {
    id: "finance",
    label: "Finance & administration",
    icon: Money,
    roles: ["admin", "comptable"],
    items: [
      { to: "/app/pilotage-financier", label: "📈 Pilotage financier", icon: ChartLineUp, desc: "Finances · P&L · plan 7 j · objectifs" },
      { to: "/app/encaissements", label: "💳 Encaissements & impayés", icon: Money, desc: "Paiements · factures · relances · recouvrement" },
      { to: "/app/stripe", label: "💳 Stripe", icon: Money, desc: "Liens · rapprochement · revenus en ligne" },
      { to: "/app/comptabilite-taxes", label: "🧾 Comptabilité & taxes", icon: Receipt, desc: "Livres · facturation · TPS/TVQ · QuickBooks" },
      { to: "/app/subventions", label: "💰 Subventions", icon: Money },
      { to: "/app/redressement", label: "🛠️ Redressement", icon: Money },
    ],
  },
  {
    id: "patrimoine",
    label: "Patrimoine & sinistre (privé)",
    icon: Buildings,
    roles: ["admin"],
    items: [
      { to: "/app/bouclier-fiscal", label: "🛡️ Bouclier Fiscal", icon: Shield },
      { to: "/app/immeubles", label: "🏢 Impact Immeubles", icon: Buildings },
      { to: "/app/investissement", label: "📈 Investissement", icon: ChartLineUp },
      { to: "/app/dossier-sinistre", label: "🛡️ Dossier de sinistre", icon: Buildings },
    ],
  },
  {
    id: "systeme",
    label: "IA, système & support",
    icon: Robot,
    roles: ["admin"],
    items: [
      { to: "/app/communications", label: "📣 Communications", icon: EnvelopeSimple, desc: "Courriel · SMS · annonces · modèles" },
      { to: "/app/assistants-ia", label: "🤖 Assistants IA", icon: Robot, desc: "Operator · Wingman · Camille · mémoire" },
      { to: "/app/debriefs", label: "🗣️ Debriefs équipe", icon: Article },
      { to: "/app/docs", label: "📚 Docs & Lettrage Camion", icon: Storefront },
      { to: "/app/reglages", label: "📘 Registre maître", icon: Plug, desc: "Contenu officiel · textes · tarifs" },
      { to: "/app/integrations", label: "🔌 Intégrations", icon: Plug },
      { to: "/app/administrateurs", label: "🔑 Accès & rôles", icon: UserCircle },
      { to: "/app/standard-qualite", label: "🏅 Standard Qualité", icon: ClipboardText },
      { to: "/app/audit-rentree", label: "🗂️ Audit & Rentrée", icon: ClipboardText },
      { to: "/app/franchise-pack", label: "🌐 Pack Réseau Kaizen", icon: Trophy },
      { to: "/app/franchises", label: "🤝 Partenaires & franchisés", icon: Trophy },
      { to: "/app/profil", label: "👤 Profil", icon: UserCircle },
    ],
  },
  {
    id: "pkh",
    label: "🥊 PowerKick Her",
    icon: Baby,
    roles: ["coach"],
    hide_for_admin: true,
    items: [
      { to: "/app/powerkick-her", label: "🥊 PowerKick Her", icon: Baby },
    ],
  },
];

// Liste plate dérivée (compat CommandPalette / recherche ⌘K).
const NAV_LABELS = {
  pilotage: "Centre de pilotage", dojo: "Dojo & élèves", competition: "Compétitions & événements", crm: "CRM & relations",
  marketing: "Marketing & contenu", boutique: "Boutique & monétisation", finance: "Finance & administration", systeme: "Système & support",
};
const NAV_MOVES = {};
// Masqués du menu (toujours accessibles par URL et via « Plan du site »)
export const NAV_HIDDEN = new Set(["/app/apercu-membre"]);
const ALL_PAGES_ITEM = { to: "/app/toutes-pages", label: "🗂️ Plan du site", icon: House };
const ARCHIVES_ITEM = { to: "/app/archives-gdn", label: "🗄️ Archives (Gladiateur du Nord)", icon: House };

function buildNavGroups() {
  const groups = NAV_GROUPS_RAW.filter((g) => g.id !== "patrimoine").map((g) => ({ ...g, label: NAV_LABELS[g.id] || g.label, items: [] }));
  const byId = Object.fromEntries(groups.map((g) => [g.id, g]));
  NAV_GROUPS_RAW.forEach((g) => (g.items || []).forEach((it) => {
    if (NAV_HIDDEN.has(it.to)) return;
    const target = byId[NAV_MOVES[it.to] || (g.id === "patrimoine" ? "finance" : g.id)] || byId[g.id];
    if (target) target.items.push(it);
  }));
  byId.systeme?.items.push(ARCHIVES_ITEM, ALL_PAGES_ITEM);
  return groups;
}
export const NAV_GROUPS = buildNavGroups();
// Liste complète (y compris masqués) pour « Toutes les pages » et l'éditeur Espace admin.
export const NAV_ALL = [...NAV_GROUPS_RAW.flatMap((g) => (g.items || []).map((it) => ({ ...it, group: NAV_LABELS[g.id] || (g.id === "patrimoine" ? "Finance & administration" : g.label) }))), { ...ARCHIVES_ITEM, group: "Système & support" }, { ...ALL_PAGES_ITEM, group: "Système & support" }];
export const NAV = NAV_GROUPS.flatMap((g) => g.items);

// ── Menu simplifié (Ralph, oct. 2026) : 5 FLUX métier. Aucune URL modifiée ; la RBAC reste calculée sur NAV_GROUPS. ──
export const NAV_FLOWS = [
  { id: "encaisser", label: "Encaisser", icon: Money, desc: "Paiements · Stripe · boutique · billetterie" },
  { id: "inscrire", label: "Inscrire", icon: UserPlus, desc: "Prospects · inscriptions · contrats · activation" },
  { id: "enseigner", label: "Enseigner", icon: Barbell, desc: "Horaire · présences · progression · événements" },
  { id: "communiquer", label: "Communiquer", icon: Megaphone, desc: "Courriels · SMS · réseaux · marketing" },
  { id: "comptabiliser", label: "Comptabiliser", icon: ChartLineUp, desc: "Finance · rapports · pilotage · système" },
  { id: "fondateur", label: "Espace Fondateur", icon: Star, desc: "Privé · alignement · décisions · patrimoine" },
];
const FLOW_BY_GROUP = {
  reception: "inscrire", pilotage: "comptabiliser", fondateur: "fondateur", dojo: "enseigner", competition: "enseigner", crm: "inscrire", marketing: "communiquer",
  boutique: "encaisser", finance: "comptabiliser", patrimoine: "comptabiliser", systeme: "comptabiliser", pkh: "inscrire",
};
const FLOW_BY_PATH = {
  // Encaisser
  "/app/encaissements": "encaisser", "/app/stripe": "encaisser", "/app/grille-tarifaire": "encaisser", "/app/premier-mois": "encaisser",
  "/app/billetterie": "encaisser", "/app/financement": "encaisser", "/app/commandites": "encaisser", "/app/offres": "encaisser",
  "/app/retention": "encaisser", "/app/facturation-membres": "encaisser", "/app/boutique": "encaisser",
  // Inscrire
  "/app/inscriptions-en-attente": "inscrire", "/app/qr-essai": "inscrire", "/app/activation-membres": "inscrire", "/app/eleves": "inscrire",
  "/app/checkin-essai": "inscrire", "/app/audit-membres": "inscrire", "/app/reconciliation-membres": "inscrire", "/app/liens-onboarding": "inscrire",
  "/app/imports": "inscrire", "/app/reclamations-assurance": "inscrire",
  // Enseigner
  "/app/calendrier": "enseigner", "/app/academie-kaizen": "enseigner", "/app/academie": "enseigner", "/app/programme-amikobi": "enseigner",
  "/app/tournee-regionale": "enseigner", "/app/videos": "enseigner", "/app/guides": "enseigner",
  // Communiquer
  "/app/studio-creatif": "communiquer", "/app/publications": "communiquer", "/app/campagnes": "communiquer", "/app/avis-google": "communiquer",
  "/app/rencontre-rentree": "communiquer", "/app/inbox-sociale": "communiquer", "/app/onboarding-sequence": "communiquer", "/app/partenariats": "communiquer",
  "/app/communications": "communiquer", "/app/assistants-ia": "communiquer", "/app/camille-phone": "communiquer", "/app/debriefs": "communiquer",
  "/app/prospects-gmail": "communiquer",
  // Comptabiliser
  "/app/taches": "comptabiliser", "/app/anomalies": "comptabiliser", "/app/fournisseurs-b2b": "comptabiliser", "/app/subventions": "comptabiliser",
  "/app/cataley": "fondateur", "/app/pilotage-financier": "comptabiliser", "/app/comptabilite-taxes": "comptabiliser",
};
function buildNavFlows() {
  const flows = NAV_FLOWS.map((f) => ({ ...f, items: [] }));
  const byId = Object.fromEntries(flows.map((f) => [f.id, f]));
  const seen = new Set();
  NAV_GROUPS.forEach((g) => g.items.forEach((it) => {
    if (seen.has(it.to)) return;
    seen.add(it.to);
    const fid = FLOW_BY_PATH[it.to] || FLOW_BY_GROUP[g.id] || "comptabiliser";
    byId[fid].items.push({ ...it, _gid: g.id });
  }));
  return flows;
}
export const NAV_FLOWS_BUILT = buildNavFlows();

// Rôles autorisés à entrer dans /app (sinon écran « accès restreint »).
export const APP_STAFF_ROLES = ["admin", "coach", "comptable", "reception", "marketing", "custom", "reception_prospects"];

function _userRoles(user) {
  const roles = (user && user.roles) || [];
  if (user && (user.is_admin || roles.includes("admin"))) return ["admin", ...roles];
  return roles;
}

// 🔑 Administrateur NON propriétaire → « Espace Administrateur » : ne voit que les pages choisies par le CEO.
export const ADMIN_SPACE_PATH = "/app/espace-admin";
export function isRestrictedAdmin(user) {
  return !!user && !!user.is_admin && !user.is_owner;
}
export function isFullAdmin(user) {
  return !!user && (user.is_admin || _userRoles(user).includes("admin")) && !isRestrictedAdmin(user);
}
function _adminItemAllowed(pathname, user) {
  if (pathname === ADMIN_SPACE_PATH || pathname === "/app/profil") return true;
  const allowed = (user.allowed_paths || []).map((p) => (LEGACY_REDIRECTS[p] || p).split("?")[0]);
  return allowed.some((p) => pathname === p || pathname.startsWith(p + "/"));
}
export function visibleItems(group, user) {
  if (isRestrictedAdmin(user)) return group.items.filter((it) => _adminItemAllowed(it.to, user));
  return group.items;
}

// Un accès PERSONNALISÉ (role=custom) est défini par la liste explicite de pôles autorisés.
function _customGroups(user) {
  if (!user) return null;
  const ag = user.allowed_groups || [];
  if ((user.role === "custom" || (user.roles || []).includes("custom")) && Array.isArray(ag)) return ag;
  return null;
}

export function userCanSeeGroup(group, user) {
  if (!user) return false;
  if (group.owner_only) return !!user.is_fondateur;
  if (isRestrictedAdmin(user)) return visibleItems(group, user).length > 0;
  if (user.is_admin || _userRoles(user).includes("admin")) return !group.hide_for_admin;
  const custom = _customGroups(user);
  if (custom) return custom.includes(group.id);
  return (group.roles || []).some((r) => _userRoles(user).includes(r));
}

export function pathAllowedForUser(pathname, user) {
  if (!user) return false;
  const ownerGroup = NAV_GROUPS.find((g) => g.owner_only && g.items.some((it) => pathname === it.to || pathname.startsWith(it.to + "/")));
  if (ownerGroup) return !!user.is_fondateur;
  if (isRestrictedAdmin(user)) return _adminItemAllowed(pathname, user);
  if (user.is_admin || _userRoles(user).includes("admin")) return true;
  if (pathname === "/app/profil") return true;
  const group = NAV_GROUPS.find((g) =>
    g.items.some((it) => it.to === pathname || (it.to !== "/app" && pathname.startsWith(it.to + "/"))));
  if (!group) return false;
  const custom = _customGroups(user);
  if (custom) return custom.includes(group.id);
  return (group.roles || []).some((r) => _userRoles(user).includes(r));
}

// Première route autorisée pour un membre d'équipe (redirection depuis /app si non autorisé).
export function firstAllowedPath(user) {
  if (!user) return "/app";
  if (isRestrictedAdmin(user)) return ADMIN_SPACE_PATH;
  if (user.is_admin || _userRoles(user).includes("admin")) return "/app";
  const grp = NAV_GROUPS.find((g) => userCanSeeGroup(g, user) && (g.items || []).length);
  if (grp) {
    const item = grp.items.find((it) => it.to !== "/app") || grp.items[0];
    if (item) return item.to;
  }
  return "/app/profil";
}

const OPEN_KEY = "kaizen_nav_open_groups";
const FAV_KEY = "kaizen_nav_favorites";
const HOME_KEY = "kaizen_nav_home";

// Item de navigation réutilisable (groupes + favoris). Étoile d'épinglage au survol.
function SidebarItem({ n, unreadContacts, convAlerts, pcAlerts, isFav, onToggleFav, favMode, isHome, onSetHome, dragProps }) {
  const Icon = n.icon;
  const showBadge = n.to === "/app/contact" && unreadContacts > 0;
  const showConv = n.to === "/app/conversion-globale" && convAlerts > 0;
  const showPC = n.to === "/app/centre-suivi" && pcAlerts > 0;
  const fav = isFav(n.to);
  const rightPad = favMode ? "pr-16" : "pr-9";
  return (
    <div
      className={`relative group/item ${favMode ? "cursor-grab active:cursor-grabbing" : ""}`}
      {...(favMode ? dragProps : {})}
    >
      <NavLink
        to={n.to}
        end={n.exact}
        data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
        className={({ isActive }) =>
          `flex items-center gap-3 pl-7 ${rightPad} py-2 mx-2 my-0.5 rounded-lg text-sm transition-all ${
            isActive
              ? "bg-amber-500/10 text-amber-400 font-semibold border-l-2 border-amber-500 shadow-[0_0_10px_rgba(245,158,11,0.08)]"
              : "text-zinc-400 hover:bg-zinc-900 hover:text-zinc-100 border-l-2 border-transparent"
          }`
        }
      >
        <Icon size={16} weight="regular" className="shrink-0" />
        <span className="flex-1 min-w-0">
          <span className="block truncate">{n.label}</span>
          {n.desc && <span className="block truncate text-[10px] text-zinc-500 font-normal mt-0.5">{n.desc}</span>}
        </span>
        {showBadge && (
          <span data-testid="nav-contact-badge" className="bg-amber-500 text-zinc-950 text-[10px] font-bold px-1.5 py-0.5 leading-none min-w-[18px] text-center rounded-full">
            {unreadContacts > 99 ? "99+" : unreadContacts}
          </span>
        )}
        {showConv && (
          <span data-testid="nav-conversion-badge" title="Nouvelles conversions sociales" className="bg-emerald-500 text-zinc-950 text-[10px] font-bold px-1.5 py-0.5 leading-none min-w-[18px] text-center rounded-full animate-pulse">
            {convAlerts > 99 ? "99+" : convAlerts}
          </span>
        )}
        {showPC && (
          <span data-testid="nav-prospect-center-badge" title="Demandes / contrats en cours à traiter" className="bg-orange-500 text-zinc-950 text-[10px] font-bold px-1.5 py-0.5 leading-none min-w-[18px] text-center rounded-full animate-pulse">
            {pcAlerts > 99 ? "99+" : pcAlerts}
          </span>
        )}
      </NavLink>
      <div className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-1">
        {favMode && (
          <button
            type="button"
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); onSetHome(n.to); }}
            data-testid={`nav-home-toggle-${n.to.replace("/app/", "").replace(/\//g, "-") || "home"}`}
            title={isHome ? "Page d'accueil par défaut" : "Définir comme page d'accueil"}
            className={`p-1 rounded transition-opacity ${
              isHome ? "opacity-100 text-amber-400" : "opacity-0 group-hover/item:opacity-100 text-zinc-500 hover:text-amber-400"
            }`}
          >
            <House size={14} weight={isHome ? "fill" : "regular"} />
          </button>
        )}
        <button
          type="button"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); onToggleFav(n.to); }}
          data-testid={`nav-fav-toggle-${n.to.replace("/app/", "").replace(/\//g, "-") || "home"}`}
          title={fav ? "Retirer des favoris" : "Épingler aux favoris"}
          className={`p-1 rounded transition-opacity ${
            fav ? "opacity-100 text-amber-400" : "opacity-0 group-hover/item:opacity-100 text-zinc-500 hover:text-amber-400"
          }`}
        >
          <Star size={14} weight={fav ? "fill" : "regular"} />
        </button>
      </div>
    </div>
  );
}

// Fil d'Ariane (Accueil › Flux › Page) pour les pages simples ; les hubs ont le leur.
function PageCrumb({ pathname }) {
  if (pathname === "/app" || LEGACY_REDIRECTS[pathname] || HUB_META[pathname]) return null;
  const match = (it) => it.to === pathname || (it.to !== "/app" && pathname.startsWith(it.to + "/"));
  const flow = NAV_FLOWS_BUILT.find((f) => f.items.some(match));
  const item = flow?.items.find(match);
  if (!item) return null;
  return (
    <nav className="px-6 pt-3 -mb-2 flex items-center gap-1.5 text-xs text-zinc-500" data-testid="page-crumb" aria-label="Fil d'Ariane">
      <Link to="/app" className="hover:text-amber-400 transition-colors">Accueil</Link>
      <CaretRight size={11} weight="bold" className="text-zinc-700" />
      <span>{flow.label}</span>
      <CaretRight size={11} weight="bold" className="text-zinc-700" />
      <span className="text-zinc-300 font-semibold">{item.label.replace(/^[^\p{L}\p{N}]+/u, "")}</span>
      {pathname === "/app/immeubles/dossier-brebeuf" && (<><CaretRight size={11} weight="bold" className="text-zinc-700" /><span className="text-amber-300 font-semibold">Dossier Brébeuf (privé)</span></>)}
    </nav>
  );
}

export default function DashboardLayout() {
  const { user, logout, setRolePreview } = useAuth();
  const [version, setVersion] = useState("");
  const [unreadContacts, setUnreadContacts] = useState(0);
  const [navBadges, setNavBadges] = useState({});
  const prevNouveauRef = useRef(null);
  const playDing = () => {
    try {
      const Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return;
      const ctx = new Ctx();
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.connect(g); g.connect(ctx.destination);
      o.type = "sine"; o.frequency.value = 880;
      g.gain.setValueAtTime(0.0001, ctx.currentTime);
      g.gain.exponentialRampToValueAtTime(0.12, ctx.currentTime + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.35);
      o.start(); o.stop(ctx.currentTime + 0.36);
      setTimeout(() => ctx.close().catch(() => {}), 500);
    } catch (e) { /* silencieux */ }
  };
  const [gmailHealth, setGmailHealth] = useState(null);
  const [theme, toggleTheme] = useTheme();
  const [comfort, setComfort] = useState(() => {
    try { return JSON.parse(localStorage.getItem("kaizen_reading_comfort") || "null") || { size: "large", contrast: false }; }
    catch (e) { return { size: "large", contrast: false }; }
  });
  const [notifs, setNotifs] = useState({ notifications: [], count: 0, urgent: 0 });
  const [notifOpen, setNotifOpen] = useState(false);
  const [digestSending, setDigestSending] = useState(false);
  const loadNotifs = async () => {
    try { const { data } = await api.get("/notifications"); setNotifs(data); } catch (e) { /* ignore */ }
  };
  useEffect(() => {
    loadNotifs();
    const iv = setInterval(loadNotifs, 60000);
    return () => clearInterval(iv);
  }, []);
  const dismissNotif = async (id) => {
    setNotifs((n) => ({ ...n, notifications: n.notifications.filter((x) => x.id !== id), count: Math.max(0, n.count - 1) }));
    try { await api.post("/notifications/dismiss", { id }); } catch (e) { /* ignore */ }
  };
  const sendDigest = async () => {
    setDigestSending(true);
    try { const { data } = await api.post("/notifications/email-digest"); toast.success(data.sent ? `Résumé envoyé (${data.count} rappels)` : "Aucune notification à envoyer"); }
    catch (e) { toast.error("Envoi impossible", { description: e?.response?.data?.detail || "" }); }
    finally { setDigestSending(false); }
  };
  useEffect(() => {
    const el = document.documentElement;
    el.classList.remove("rc-large", "rc-xl", "rc-contrast");
    if (comfort.size === "large") el.classList.add("rc-large");
    if (comfort.size === "xl") el.classList.add("rc-xl");
    if (comfort.contrast) el.classList.add("rc-contrast");
    try { localStorage.setItem("kaizen_reading_comfort", JSON.stringify(comfort)); } catch (e) { /* ignore */ }
  }, [comfort]);
  const [gmailReconnecting, setGmailReconnecting] = useState(false);
  const reconnectGmail = async () => {
    setGmailReconnecting(true);
    try {
      const { data } = await api.get("/integrations/gmail/auth-url");
      if (data?.auth_url) {
        window.open(data.auth_url, "_blank", "noopener,noreferrer");
        toast.success("Fenêtre Google ouverte", { description: "Autorise l'accès Gmail, puis reviens ici. Le bandeau disparaîtra automatiquement." });
      } else {
        toast.error("Impossible d'obtenir le lien de reconnexion Gmail.");
      }
    } catch (e) {
      toast.error("Reconnexion Gmail impossible", { description: e?.response?.data?.detail || "Vérifie la configuration Google dans Intégrations." });
    } finally {
      setGmailReconnecting(false);
    }
  };
  const [openGroups, setOpenGroups] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(OPEN_KEY) || "null");
      if (saved && typeof saved === "object" && NAV_FLOWS.some((f) => f.id in saved)) return saved;
    } catch (e) { /* ignore */ }
    // Par défaut : seul le flux contenant la page courante est ouvert.
    const path = window.location.pathname;
    const init = {};
    NAV_FLOWS_BUILT.forEach((f) => { init[f.id] = f.items.some((it) => it.to === path); });
    return init;
  });

  const toggleGroup = (id) => {
    setOpenGroups((prev) => {
      const next = { ...prev, [id]: !prev[id] };
      try { localStorage.setItem(OPEN_KEY, JSON.stringify(next)); } catch (e) { /* ignore */ }
      return next;
    });
  };

  const [favorites, setFavorites] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(FAV_KEY) || "null");
      if (Array.isArray(saved)) return saved;
    } catch (e) { /* ignore */ }
    return [];
  });
  const [favOpen, setFavOpen] = useState(true);
  const isFav = (to) => favorites.includes(to);
  const toggleFav = (to) => {
    setFavorites((prev) => {
      const next = prev.includes(to) ? prev.filter((x) => x !== to) : [...prev, to];
      try { localStorage.setItem(FAV_KEY, JSON.stringify(next)); } catch (e) { /* ignore */ }
      return next;
    });
  };
  // Page d'accueil par défaut (une route favorite vers laquelle rediriger au démarrage).
  const [homeFav, setHomeFav] = useState(() => {
    try { return localStorage.getItem(HOME_KEY) || ""; } catch (e) { return ""; }
  });
  const navigate = useNavigate();
  const location = useLocation();
  const setHome = (to) => {
    setHomeFav((prev) => {
      const next = prev === to ? "" : to;
      try { next ? localStorage.setItem(HOME_KEY, next) : localStorage.removeItem(HOME_KEY); } catch (e) { /* ignore */ }
      return next;
    });
  };
  // Redirection vers la page d'accueil : UNE seule fois par session d'onglet,
  // quand l'utilisateur se trouve sur l'index /app (au démarrage / après login).
  useEffect(() => {
    if (homeFav && homeFav !== "/app" && location.pathname === "/app") {
      let done = false;
      try { done = sessionStorage.getItem("kaizen_home_redirected") === "1"; } catch (e) { /* ignore */ }
      if (!done) {
        try { sessionStorage.setItem("kaizen_home_redirected", "1"); } catch (e) { /* ignore */ }
        navigate(homeFav, { replace: true });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, homeFav]);
  // Glisser-déposer pour réordonner les favoris.
  const [dragTo, setDragTo] = useState(null);
  const reorderFav = (fromTo, toTo) => {
    if (fromTo === toTo) return;
    setFavorites((prev) => {
      const arr = [...prev];
      const from = arr.indexOf(fromTo);
      if (from < 0) return prev;
      arr.splice(from, 1);
      const to = arr.indexOf(toTo);
      const insertAt = to < 0 ? arr.length : to;
      arr.splice(insertAt, 0, fromTo);
      try { localStorage.setItem(FAV_KEY, JSON.stringify(arr)); } catch (e) { /* ignore */ }
      return arr;
    });
  };
  // Items favoris résolus + filtrés selon les pôles visibles par le rôle.
  const allowedPaths = new Set(NAV_GROUPS.filter((g) => userCanSeeGroup(g, user)).flatMap((g) => visibleItems(g, user).map((it) => it.to)));
  const favItems = favorites
    .map((to) => NAV.find((n) => n.to === to))
    .filter((n) => n && allowedPaths.has(n.to));
  // 5 flux filtrés par la RBAC existante ; recherche rapide accent-insensible.
  const flows = NAV_FLOWS_BUILT.map((f) => ({ ...f, items: f.items.filter((it) => allowedPaths.has(it.to)) })).filter((f) => f.items.length);

  useEffect(() => {
    api.get("/version").then(r => setVersion(r.data.version)).catch(() => {});
    const fetchUnread = () => {
      api.get("/contact-messages/count")
        .then(r => setUnreadContacts(r.data.unread || 0))
        .catch(() => {});
    };
    fetchUnread();
    const interval = setInterval(fetchUnread, 30000);

    const fetchBadges = () => {
      api.get("/nav/badges").then(r => {
        const data = r.data || {};
        const cur = data.inbox_nouveau || 0;
        const prev = prevNouveauRef.current;
        if (prev !== null && cur > prev) {
          const n = cur - prev;
          playDing();
          toast.success(`💬 ${n} nouveau${n > 1 ? "x" : ""} message${n > 1 ? "s" : ""} dans l'Inbox`, {
            description: "Réponds vite pour maximiser la conversion.",
            action: { label: "Ouvrir", onClick: () => navigate("/app/inbox-sociale") },
          });
        }
        prevNouveauRef.current = cur;
        setNavBadges(data);
      }).catch(() => {});
    };
    fetchBadges();
    const badgesInterval = setInterval(fetchBadges, 30000);

    const fetchGmailHealth = () => {
      api.get("/integrations/gmail/health")
        .then(r => setGmailHealth(r.data))
        .catch(() => setGmailHealth(null));
    };
    fetchGmailHealth();
    const gmailInterval = setInterval(fetchGmailHealth, 5 * 60 * 1000);

    return () => {
      clearInterval(interval);
      clearInterval(badgesInterval);
      clearInterval(gmailInterval);
    };
  }, []);

  return (
    <div className="min-h-screen flex bg-zinc-950 text-zinc-100" data-testid="dashboard-shell">
      {/* Sidebar */}
      <aside className="w-64 hidden md:flex md:flex-col sticky top-0 h-screen border-r border-zinc-800 bg-zinc-950 overflow-y-auto custom-scrollbar">
        <Link to="/app" className="px-5 h-[72px] flex items-center border-b border-zinc-800 sticky top-0 bg-zinc-950 z-10 hover:bg-zinc-900/40 transition-colors">
          <Logo variant="static" product />
        </Link>
        <div className="px-3 py-3 border-b border-zinc-800/60">
          <CommandPalette />
        </div>
        <nav className="flex-1 py-2">
          {isRestrictedAdmin(user) && (
            <div className="mb-2 px-2" data-testid="nav-admin-space">
              <NavLink to={ADMIN_SPACE_PATH} data-testid="nav-admin-space-link"
                className={({ isActive }) => `flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm font-bold transition-colors ${isActive ? "bg-amber-500 text-zinc-950" : "bg-zinc-900 text-amber-300 hover:bg-zinc-800"}`}>
                <Shield size={16} weight="duotone" /> Espace Administrateur
              </NavLink>
              <div className="mx-2 mt-2 border-t border-zinc-800/60" />
            </div>
          )}
          {favItems.length > 0 && (
            <div className="mb-2" data-testid="nav-favorites">
              <button
                type="button"
                onClick={() => setFavOpen((o) => !o)}
                data-testid="nav-group-favorites"
                aria-expanded={favOpen}
                className="w-full group flex items-center gap-2.5 px-4 py-2 text-[11px] uppercase tracking-[0.14em] font-bold text-amber-400/90 hover:text-amber-300 transition-colors"
              >
                <Star size={15} weight="fill" className="text-amber-500" />
                <span className="flex-1 text-left truncate">Favoris</span>
                <CaretDown size={12} weight="bold" className={`transition-transform duration-200 ${favOpen ? "rotate-180" : ""}`} />
              </button>
              {favOpen && (
                <div className="mt-0.5 mb-1">
                  {favItems.map((n) => (
                    <SidebarItem
                      key={`fav-${n.to}`}
                      n={n}
                      unreadContacts={unreadContacts}
                      convAlerts={navBadges.conversions_new || 0}
                      pcAlerts={navBadges.prospect_center || 0}
                      isFav={isFav}
                      onToggleFav={toggleFav}
                      favMode
                      isHome={homeFav === n.to}
                      onSetHome={setHome}
                      dragProps={{
                        draggable: true,
                        onDragStart: () => setDragTo(n.to),
                        onDragOver: (e) => e.preventDefault(),
                        onDrop: (e) => { e.preventDefault(); if (dragTo) reorderFav(dragTo, n.to); setDragTo(null); },
                        onDragEnd: () => setDragTo(null),
                      }}
                    />
                  ))}
                </div>
              )}
              <div className="mx-4 mt-1 border-t border-zinc-800/60" />
            </div>
          )}
          {flows.map((group) => {
            const GIcon = group.icon;
            const isOpen = !!openGroups[group.id];
            const groupHasActive = group.items.some((it) => window.location.pathname === it.to);
            return (
              <div key={group.id} className="mb-1" data-testid={`nav-flow-${group.id}`}>
                <button
                  type="button"
                  onClick={() => toggleGroup(group.id)}
                  data-testid={`nav-group-${group.id}`}
                  aria-expanded={isOpen}
                  className={`w-full group flex items-center gap-2.5 px-4 py-2.5 mx-0 text-left transition-colors ${
                    groupHasActive ? "text-amber-400" : "text-zinc-400 hover:text-zinc-100"
                  }`}
                >
                  <GIcon size={17} weight="bold" className={groupHasActive ? "text-amber-500" : "text-zinc-600 group-hover:text-amber-500/70"} />
                  <span className="flex-1 min-w-0">
                    <span className="block text-[12px] uppercase tracking-[0.14em] font-bold truncate">{group.label}</span>
                    <span className="block text-[10px] text-zinc-600 truncate normal-case tracking-normal font-normal">{group.desc}</span>
                  </span>
                  <span className="text-[10px] text-zinc-600 tabular-nums" data-testid={`nav-flow-count-${group.id}`}>{group.items.length}</span>
                  <CaretDown size={12} weight="bold" className={`transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`} />
                </button>
                {isOpen && (
                  <div className="mt-0.5 mb-2">
                    {group.items.map((n) => (
                      <SidebarItem key={n.to} n={n} unreadContacts={unreadContacts} convAlerts={navBadges.conversions_new || 0} pcAlerts={navBadges.prospect_center || 0} isFav={isFav} onToggleFav={toggleFav} />
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </nav>
        <div className="border-t border-zinc-800 p-4 bg-zinc-950 sticky bottom-0">
          <div className="flex items-center gap-3 mb-3">
            {user?.picture ? (
              <img src={user.picture} alt="" referrerPolicy="no-referrer" data-testid="user-avatar"
                className="w-9 h-9 rounded-full object-cover border border-zinc-700 shrink-0" />
            ) : (
              <div data-testid="user-avatar-initials"
                className="w-9 h-9 rounded-full bg-amber-500 text-zinc-950 flex items-center justify-center text-sm font-bold shrink-0">
                {(user?.full_name || user?.email || "?").trim().charAt(0).toUpperCase()}
              </div>
            )}
            <div className="min-w-0">
              <div className="text-sm font-semibold text-zinc-100 truncate" data-testid="user-fullname">{user?.full_name}</div>
              <div className="text-[11px] text-zinc-500 truncate" data-testid="user-email">{user?.email}</div>
            </div>
          </div>
          <button onClick={logout} data-testid="logout-btn" className="w-full px-3 py-2 rounded-lg text-xs uppercase tracking-wider font-semibold border border-zinc-800 text-zinc-400 hover:bg-amber-500 hover:text-zinc-950 hover:border-amber-500 transition-all flex items-center justify-center gap-2">
            <SignOut size={13} /> Déconnexion
          </button>
          {version && <div className="text-[10px] text-zinc-600 text-center mt-3 uppercase tracking-widest" data-testid="app-version">v{version}</div>}
          <div className="mt-3 pt-3 border-t border-zinc-900" data-testid="reading-comfort">
            <div className="text-[9px] uppercase tracking-[0.18em] text-zinc-600 mb-1.5 text-center">Confort de lecture</div>
            <div className="flex items-center gap-1.5 justify-center flex-wrap">
              {[["normal", "A"], ["large", "A+"], ["xl", "A++"]].map(([v, l]) => (
                <button key={v} onClick={() => setComfort((c) => ({ ...c, size: v }))} data-testid={`comfort-size-${v}`}
                  title={`Taille du texte : ${l}`}
                  className={`px-2 py-1 rounded text-[11px] font-bold border transition-colors ${
                    comfort.size === v ? "bg-amber-500 text-zinc-950 border-amber-500" : "bg-zinc-900 text-zinc-400 border-zinc-800 hover:text-zinc-200"}`}>
                  {l}
                </button>
              ))}
              <button onClick={() => toggleTheme()} data-testid="comfort-theme"
                title={theme === "light" ? "Passer en mode sombre" : "Passer en mode clair"}
                className={`px-2 py-1 rounded text-[11px] font-bold border transition-colors flex items-center gap-1 ${
                  theme === "light" ? "bg-amber-500 text-zinc-950 border-amber-500" : "bg-zinc-900 text-zinc-400 border-zinc-800 hover:text-zinc-200"}`}>
                {theme === "light" ? <Moon size={11} /> : <Sun size={11} />} {theme === "light" ? "Clair" : "Sombre"}
              </button>
              <button onClick={() => setComfort((c) => ({ ...c, contrast: !c.contrast }))} data-testid="comfort-contrast"
                title="Renforcer le contraste du texte"
                className={`px-2 py-1 rounded text-[11px] font-bold border transition-colors ${
                  comfort.contrast ? "bg-amber-500 text-zinc-950 border-amber-500" : "bg-zinc-900 text-zinc-400 border-zinc-800 hover:text-zinc-200"}`}>
                Contraste+
              </button>
            </div>
          </div>
          <div className="mt-3 pt-3 border-t border-zinc-900">
            <button type="button" onClick={() => window.dispatchEvent(new Event("dojova:tour"))} data-testid="sidebar-tour-btn"
              className="w-full mb-2 inline-flex items-center justify-center gap-2 rounded-lg border border-amber-500/30 text-amber-300 hover:bg-amber-500/10 px-3 py-2 text-xs font-medium transition-colors">
              <Sparkle size={13} weight="fill" /> Visite guidée (2 min)
            </button>
            <div className="text-center text-[9px] uppercase tracking-[0.22em] text-zinc-600">
              <span className="text-amber-500/90 font-bold tracking-[0.32em]">DOJOVA</span>
              <span className="mx-1.5 text-zinc-700">—</span>
              <span className="text-zinc-500 font-semibold">Kaizen System</span>
            </div>
          </div>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 min-w-0 bg-zinc-950">
        {user?.role_preview && (
          <div className="sticky top-0 z-[70] flex flex-wrap items-center justify-between gap-2 bg-amber-500 px-4 py-2 text-sm font-semibold text-black" data-testid="role-preview-banner">
            <span>👁 Aperçu du rôle « {user.role_preview.label} » — tu vois exactement les pages ouvertes à ce rôle (tes droits réels sont intacts).</span>
            <button onClick={() => { setRolePreview(null); navigate("/app/administrateurs"); }} className="rounded-full bg-black px-3 py-1 text-xs text-amber-300" data-testid="role-preview-exit">Quitter l'aperçu</button>
          </div>
        )}
        {/* Cloche de notifications + compteur courriels */}
        <DraggableWidget id="email-quota" defaultStyle={{ top: 16, right: 76 }} zIndex={60}>
          <EmailQuotaBadge />
        </DraggableWidget>
        <DraggableWidget id="notif-bell" defaultStyle={{ top: 16, right: 20 }} zIndex={60} className="flex items-start gap-2">
          <div className="relative" data-testid="notif-bell-wrap">
          <button onClick={() => { setNotifOpen((o) => !o); if (!notifOpen) loadNotifs(); }} data-testid="notif-bell"
            className="relative w-11 h-11 rounded-full bg-zinc-900 border border-zinc-700 flex items-center justify-center text-zinc-300 hover:text-white hover:border-zinc-500 shadow-lg transition-colors">
            <Bell size={20} weight={notifs.urgent ? "fill" : "regular"} />
            {notifs.count > 0 && (
              <span className={`absolute -top-1 -right-1 min-w-[20px] h-5 px-1 rounded-full text-[11px] font-bold flex items-center justify-center ${notifs.urgent ? "bg-[#D90429] text-white" : "bg-amber-500 text-zinc-950"}`} data-testid="notif-count">{notifs.count}</span>
            )}
          </button>
          {notifOpen && (
            <div className="absolute right-0 mt-2 w-[360px] max-h-[70vh] overflow-y-auto rounded-xl bg-zinc-900 border border-zinc-700 shadow-2xl custom-scrollbar cursor-auto" data-testid="notif-panel" onPointerDown={(e) => e.stopPropagation()}>
              <div className="px-4 py-3 border-b border-zinc-800 flex items-center justify-between sticky top-0 bg-zinc-900">
                <span className="font-semibold text-zinc-100">Notifications</span>
                <button onClick={() => setNotifOpen(false)} className="text-zinc-500 hover:text-zinc-200"><X size={16} /></button>
              </div>
              {notifs.notifications.length === 0 ? (
                <div className="px-4 py-8 text-center text-sm text-zinc-500" data-testid="notif-empty">Tout est à jour 🎉</div>
              ) : (
                <div className="divide-y divide-zinc-800">
                  {notifs.notifications.map((n) => (
                    <div key={n.id} className="px-4 py-3 hover:bg-zinc-800/50 flex items-start gap-2" data-testid={`notif-${n.id}`}>
                      <span className={`mt-1.5 w-2 h-2 rounded-full shrink-0 ${n.severity === "urgent" ? "bg-[#D90429]" : "bg-amber-500"}`} />
                      <button onClick={() => { setNotifOpen(false); if (n.link) navigate(n.link); }} className="flex-1 text-left">
                        <div className="text-sm font-medium text-zinc-100 leading-snug">{n.title}</div>
                        {n.detail && <div className="text-xs text-zinc-500 mt-0.5">{n.detail}</div>}
                      </button>
                      <button onClick={() => dismissNotif(n.id)} className="text-zinc-600 hover:text-zinc-300 shrink-0" title="Ignorer" data-testid={`dismiss-${n.id}`}><X size={14} /></button>
                    </div>
                  ))}
                </div>
              )}
              <div className="px-4 py-3 border-t border-zinc-800 sticky bottom-0 bg-zinc-900">
                <button onClick={sendDigest} disabled={digestSending} data-testid="notif-email-digest"
                  className="w-full text-xs font-semibold px-3 py-2 rounded-lg bg-zinc-800 text-zinc-200 border border-zinc-700 hover:bg-zinc-700 disabled:opacity-50 flex items-center justify-center gap-2">
                  <Envelope size={14} /> {digestSending ? "Envoi…" : "M'envoyer le résumé par courriel"}
                </button>
              </div>
            </div>
          )}
          </div>
        </DraggableWidget>
        {gmailHealth && gmailHealth.action_required && (
          <div
            className="pl-6 pr-44 py-3 flex items-center justify-between gap-4 bg-red-950 text-red-100 border-b border-red-900"
            data-testid="gmail-health-banner"
          >
            <div className="flex items-center gap-3 text-sm">
              <span style={{ fontSize: "20px" }}>⚠️</span>
              <div>
                <div className="font-bold">Gmail déconnecté ({gmailHealth.account || "compte"})</div>
                <div className="text-xs opacity-90">{gmailHealth.message}</div>
              </div>
            </div>
            <div className="flex items-center gap-3 shrink-0">
              <Link
                to="/app/integrations"
                className="hidden sm:inline text-xs text-red-200/80 hover:text-white underline underline-offset-2 transition"
                data-testid="gmail-integrations-link"
              >
                Gérer dans Intégrations
              </Link>
              <button
                type="button"
                onClick={reconnectGmail}
                disabled={gmailReconnecting}
                className="px-4 py-2 bg-amber-500 text-zinc-950 text-xs font-bold tracking-widest rounded-lg hover:bg-amber-400 disabled:opacity-60 transition flex items-center gap-2 shrink-0"
                data-testid="gmail-reconnect-btn"
              >
                <ArrowsClockwise size={14} weight="bold" className={gmailReconnecting ? "animate-spin" : ""} />
                {gmailReconnecting ? "OUVERTURE…" : "RECONNECTER GMAIL"}
              </button>
            </div>
          </div>
        )}
        {gmailHealth && gmailHealth.status === "degraded" && (
          <div
            className="pl-6 pr-44 py-2 flex items-center justify-between gap-4 bg-amber-950/60 text-amber-100 border-b border-amber-900"
            data-testid="gmail-degraded-banner"
          >
            <div className="flex items-center gap-3 text-sm">
              <span>⏳</span>
              <span>{gmailHealth.message}</span>
            </div>
          </div>
        )}
        <ConfidentialityGate user={user} />
        <PageCrumb pathname={location.pathname} />
        {location.pathname === "/app" && <div className="px-6 pt-4"><InstallAppBanner compact who="coach" /></div>}
        <Outlet />
        <GuidedTour user={user} />
      </main>
      <MascotChat mode="member" />
    </div>
  );
}
